import { Link } from 'react-router-dom';

import { useAPI } from 'hooks/api/useAPI';

import { ExternalLink } from 'components/ExternalLink/ExternalLink';

const INTERNAL_LINK_PREFIX = '/@/';

function CustomMarkdownAnchor(allProps: any) {
  const { applicationID } = useAPI();

  const href = allProps.href as string | undefined;
  const children = allProps.children;
  const className = allProps.className as string | undefined;

  // Handle /@/ prefix for internal application links
  if (href?.startsWith(INTERNAL_LINK_PREFIX)) {
    const path = href.slice(INTERNAL_LINK_PREFIX.length);
    const internalHref = `/applications/${applicationID}/${path}`;

    return (
      <Link to={internalHref} className={className}>
        {children}
      </Link>
    );
  }

  return (
    <ExternalLink href={href} className={className}>
      {children}
    </ExternalLink>
  );
}

export const customMarkdownAnchor = CustomMarkdownAnchor;
